// extracted by mini-css-extract-plugin
export default {"mCard":"mE-z","image":"nE-z","imageNoBackground":"oE-z","imageHasCategory":"pE-z","fullWidth":"qE-z"};